/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserCoin } from './UserCoin';
import {
    UserCoinFromJSON,
    UserCoinFromJSONTyped,
    UserCoinToJSON,
} from './UserCoin';

/**
 * 
 * @export
 * @interface UserCoinsResponse
 */
export interface UserCoinsResponse {
    /**
     * 
     * @type {Array<UserCoin>}
     * @memberof UserCoinsResponse
     */
    data: Array<UserCoin>;
}

/**
 * Check if a given object implements the UserCoinsResponse interface.
 */
export function instanceOfUserCoinsResponse(value: object): value is UserCoinsResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function UserCoinsResponseFromJSON(json: any): UserCoinsResponse {
    return UserCoinsResponseFromJSONTyped(json, false);
}

export function UserCoinsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCoinsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(UserCoinFromJSON)),
    };
}

export function UserCoinsResponseToJSON(value?: UserCoinsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(UserCoinToJSON)),
    };
}

